import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Procesed } from "../../../shared/enum-procesed";
import { ItineraryService } from "../../../shared/itinerary.service";
import { RestService } from "../../rest.service";
import { formatArrivalDate } from "../../../utils/Functions";
import * as moment from "moment";
import { setting } from "../../../../../setting";
import { AccordionConfig, AccordionItem } from "app/shared/modals-results-categories/accordion-info-product/accordion-info.interface";
import { ICancellationPolicyModalResultsDisplayData } from "model/view-models/results/product-card/price-display-data.interface";
import { SafeHtml } from "@angular/platform-browser";
import { NotificationService } from '../../../shared/notifications/notification.service'

@Component({
  selector: "usb-modal-rentacar",
  templateUrl: "./modal-rentacar.component.html",
  styleUrls: ["./modal-rentacar.component.scss"],
})
export class ModalRentacarComponent implements OnInit {
  @Output() refModal = new EventEmitter<any>();
  @Input() rentaCar: any;
  @Input() form: FormGroup;
  @Input() payloadUpdate?: any;
  @Input() itineraryItem?: any;
  @Input() origin?: any;
  @Input() arrayResults?: any;
  @Input() productQty?: any;
  @Input() payload?: any;
  @Input() tabActive: any;
  @Input() clientSetting: any;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() quote: boolean = true;
  @Input() action: string = '';
  @ViewChild('politicsAccordion') politicsAccordion: any;
  @ViewChild('politicsSection') politicsSection!: ElementRef;


  @ViewChild("map") gmapElement: any;
  @ViewChild("checkOptions") checkOptionsElement!: ElementRef<HTMLInputElement>;
  public formatDate = formatArrivalDate;
  result: any;

  disableButton: Boolean = true;
  selected: String = "INCLUDES";
  _findData = false;
  isChecked: any;
  qtySelect = 0;
  allCar: any;
  itemSelect: any;

  totalPaymentUsblick: any = 0;
  public totalPaymentAgency: any = 0;
  totalRent: any = 0;
  totalPrice: any = 0;

  totalSumCarsFeeAgency: any = 0; // sumar los cars fee

  totalSumOptionalAgency: any = 0;
  isMainExpandedExcutiveAction: boolean[] = [];
  optionals: any = 0;
  selectOptional = new Array();
  totalPriceOptional: any = 0;
  totalPricePaymentOffice: number = 0;
  paymentAgency: any = 0;
  paymentNow: any = 0;
  updateOptionals = false;
  otherOpcions: any;
  pickUpData: any;
  dropOffData: any;
  selectedPickup: any[] = [];
  selectedDropOff: any[] = [];
  selectedOfficePickup: any;
  selectedOfficeDropoff: any;
  dropOffTime: string = "";
  pickUpTime: string = "";
  dropOffDate: string = "";
  booleanWindowInfo: boolean = false;
  dateEndSearch: any = "";
  totalChildren: string = "";
  currencySelectedRentacar: string = "";
  agency: any;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  tab: string = "INCLUDES";
  dateIni: string;
  dateEnd: string;
  timeIni: string;
  timeEnd: string;

  totalOptional: any = [];
  rentacarLocations: any[] = [];
  officesNotRepeated: any[] = [];
  pricePaymentAgency: string;
  mapActive: boolean = false;
  includesRentacar: any[] = [];
  insuranceRentacarArray: any[] = [];
  optionalRentacarArray: any[] = [];
  arrayCarsfees: any[] = [];
  booleanCarsfees: boolean = false;
  qtyOptionals: number = 0;
  arraySelectedCarfees: any[] = [];
  totalCarPrice: number = 0;
  booleanInputQty:boolean = false;

  openMapPickup: boolean = false;
  openMapDropoff: boolean = false;
  days: number = 1;

  valueDefault = parseFloat("90.80").toFixed(2);
  public getClientsSettingAppBooking: any;
  coordinatesArr: any[] = [];
  pickupLocation: any;
  dropoffLocation: any;
  officeCharges: boolean = false;


  cancellationData!: ICancellationPolicyModalResultsDisplayData;
  accordionItemsData!: AccordionItem[];
  accordionConfigData!: AccordionConfig;
  requirementsData: SafeHtml = '';


  constructor(
    private _itineraryService: ItineraryService,
    private _rest: RestService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
  }

  ngOnInit() {

    this.result = this.rentaCar;
    this.payload = this.payloadUpdate;
    if(this.quote) {
    this.arrayResults.forEach((option: any) => {
      option.additionalInfo.carRental.addonsIncluded = [];
      option.additionalInfo.carRental.netPriceBookingAddons = option.additionalInfo.carRental.totalPriceProf;
    });
    }

    this.allCar = this.arrayResults;

    // eslint-disable-next-line max-len


    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;

    this.tab = this.tabActive ? this.tabActive : "INFO";

    this.clientSetting = JSON.parse(localStorage.getItem(setting.name));
    this.agency = JSON.parse(localStorage.getItem("selectedAgency"));

    let dateEndForm = JSON.parse(localStorage.getItem("form"));

    if(!this.quote) {
      this.result.additionalInfo = {images: this.result.images};
      dateEndForm = this.rentaCar.form;
    }
    const dateSubtract = moment(dateEndForm.dateEnd, "DD-MM-YYYY").subtract(1, "days");
    this.dateEndSearch = dateSubtract.format("DD-MM-YYYY");

    let payloadTime = JSON.parse(localStorage.getItem("payload"));

    if(!this.quote) {
      payloadTime = this.rentaCar.payloadUpdate.products;
    }

    this.dropOffDate = moment(payloadTime[0].others.carRental.dropoffLocation.dropoffDate).subtract(1, "days").format("DD-MM-YYYY");

    this.pickUpTime = moment(payloadTime[0].others.carRental.pickupLocation.pickupTime, "HH:mm:ss").format("HH:mm");
    this.dropOffTime = moment(payloadTime[0].others.carRental.dropoffLocation.dropoffTime, "HH:mm:ss").format("HH:mm");

    if(this.quote) {
      this.result.additionalInfo.carRental.addonsIncluded = [];
      this.result.additionalInfo.carRental.netPriceBookingAddons = this.result.additionalInfo.carRental.totalPriceProf;
    }


    this.days = this.getDays(payloadTime[0].arrivalDate,
                             payloadTime[0].departureDate);
    this.arrayResults = JSON.parse(
      JSON.stringify(
        this.arrayResults.filter(
          (element: any) => element.title === this.rentaCar.title &&
                            element.providerName === this.rentaCar.providerName &&
                            element.additionalInfo.carRental.optionRates.suplier.name === this.rentaCar.additionalInfo.carRental.optionRates.suplier.name
        )
      )
    );


    this.rentacarLocationsDetails();
    if(this.quote) {
          this.officesRepeated();
    }


    // this.timesAgencies();
    this.dateTransform();
    this.initArrayIncludes();
    // this.optionalsRentacar();
    this.loadAllOptionals();

    this.cancellationData = this.cancellationPolicies();
    this.accordionItemsData = this.accordionItems();
    this.accordionConfigData = this.accordionConfig();
    this.requirementsData = this.result.additionalInfo?.carRental?.requirements || '';
  }

    getDays(dateIn: any, dateOut: any): any {
    // Convertir a milisegundos y calcular diferencia
    const diffInMs = new Date(dateOut).getTime() - new Date(dateIn).getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays;
  }


  getQty(qty: any) {
    return Array.from({ length: qty }, (_, i) => i + 1);
  }

  _split(cadena: any) {
    return cadena.split(",")[0];
  }

  selectCar(car: any, index?: any) {
    this.itemSelect = car;
    this.totalChildren = this.itemSelect.additionalInfo.carRental.space_distribution.Niños;
    this.currencySelectedRentacar = this.itemSelect.additionalInfo.carRental.currency;
    this.showWindowInfo(this.itemSelect);
    let ind: any = 0;

    this.totalPriceOptional = Number(car.additionalInfo?.carRental?.totalPriceProf);
    this.totalPricePaymentOffice = this.getPriceAddons(car?.additionalInfo?.carRental?.addonsIncluded);
    this.totalSumCarsFeeAgency = 0;
    this.totalPaymentAgency = 0;
    this.totalPrice = 0;
    this.totalPaymentUsblick = 0;

    for (let i = 0; i < this.arrayResults.length; i++) {
      (document.getElementById(ind) as HTMLInputElement).style.border = "1px solid #87e5ad";
      (document.getElementById(ind) as HTMLInputElement).style.borderRadius = "10px";
      ind++;
    }

    const currentElement = document.getElementById(index) as HTMLInputElement;
    if (currentElement) {
      currentElement.checked = true;
      currentElement.disabled = true;
      currentElement.style.border = "3px solid #00d096";
    }

    if(car.additionalInfo.carRental.optionRates.carsfees){
      this.totalSumCarsFeeAgency = this.sumFeePaymentAgency(car.additionalInfo.carRental.optionRates.carsfees);
    }else{
      this.totalSumCarsFeeAgency = car.additionalInfo.carRental.totalPriceProf;
    }

    this.totalPaymentAgency = (parseFloat(this.totalPaymentAgency) + parseFloat(this.totalSumCarsFeeAgency)).toFixed(2);
    this.totalPaymentUsblick = Number(parseFloat(car.additionalInfo.carRental.totalPriceProf).toFixed(2));
    this.totalPrice = (parseFloat(this.totalPaymentUsblick) + parseFloat(this.totalPaymentAgency)).toFixed(2);
    // this.searchCarsrules(car.additionalInfo.carRental.RatePlanCode);
    this.updateOptionals = true;


  }

  add() {

    if(this.selectedPickup &&
       this.selectedPickup.length === 0
    ) {
      this.notificationService.info('Seleccione una oficina de retiro');
      return;
    }


    if(this.selectedDropOff &&
       this.selectedDropOff.length === 0
    ) {
      this.notificationService.info('Seleccione una oficina de devolución');
      return;
    }

    if(!this.itemSelect) {
      this.notificationService.info('Seleccione un plan de contrato');
      return;
    }

    this._findData = true;
    this.addItinerary(this.itemSelect.additionalInfo.carRental, this.itemSelect);

    this._itineraryService.itinerary.clientId = this.clientSetting?.id;
    this._itineraryService.itinerary.currency = this.currencySelectedRentacar;
    this._itineraryService.updateItinerary(this._itineraryService.itinerary);
    // this._itineraryService.itinerary.nights = this._itineraryService.itinerary?.destination[0]?.destination_info.nights;
  }

  sumTotalAgency(carsfees: any) {
    return this.sumFeePaymentAgency(carsfees);
  }

  sumTotalRent(paymentUsblick: any, paymentAgency: any) {
    return (parseFloat(paymentUsblick) + parseFloat(paymentAgency)).toFixed(2);
  }


  selectOfficeDifferents(): any[] {
    let locationsOffice: any[] = [
      {
        PickUp: [],
        OperationTime: [],
        DropOff: [],
      },
    ];

    this.rentacarLocations.find((data) => {
      if (data.PickUp.Name === this.selectedPickup) {
        const { PickUp, OperationTime, ...rest } = data;
        // console.log('pickUp ->', PickUp);
        locationsOffice[0].PickUp = PickUp;
        locationsOffice[0].OperationTime = OperationTime;
      }
    });

    this.rentacarLocations.find((data) => {
      if (data.DropOff.Name === this.selectedDropOff) {
        const { DropOff, OperationTime, ...rest } = data;
        // console.log('DropOff ->',DropOff);
        locationsOffice[0].DropOff = DropOff;
        locationsOffice[0].OperationTime = OperationTime;
      }
    });

    return locationsOffice[0];
  }

  cancelationPolicy(description: any) {
    // return description;
    let result;
    if (description) {
      result = description.split("*");

      return result[1];
    }
  }

  cancelationPolicy_(description: any) {
    // return description;
    let result;
    if (description) {
      result = description.split("*");
      return result[2];
    }
  }

  namePlan(name: any) {
    // return description;
    let result;
    if (name) {
      result = name.split(":");
      return result[0];
    }
  }

  onChangePickup(value: any) {
    let pickupValue: any;
    this.coordinatesArr = [];
    this.pickupLocation = {};
    if(value) {
      if(typeof value === 'string') {
        pickupValue = JSON.parse(value);
      } else {
        pickupValue = value;
      }
    };

    // if(this.result.additionalInfo.images && this.result.additionalInfo.images.length > 0) {
    //       this.result.additionalInfo.images[0]['is_cover'] = 1;
    //   }

    this.coordinatesArr = [{
      coordinates: {latitude: Number(pickupValue.latitude), longitude: Number(pickupValue.longitude)},
      hotel_name: pickupValue.Name,
      address: pickupValue.Address,
      images: this.result.additionalInfo.images,
      price: this.result.additionalInfo?.carRental?.totalPriceProf,
    }];

    this.pickupLocation = {
      lat: Number(pickupValue.latitude) ?? null,
      lng: Number(pickupValue.longitude) ?? null,
      name: pickupValue.Name,
      address: pickupValue.Address,
      iata: this.payload.others.carRental.pickupLocation.origin,
      type: 'airport',
      country_code: 'US',
      operationTime: pickupValue.OperationTime || [],
      phone: pickupValue.PhoneNumbers
    }
    this.selectedOfficePickup = this.pickupLocation;
  // selectedOfficeDropoff: any;
    this.selectedPickup = this.coordinatesArr;
  }

  onChangeDropOff(value: any) {
    let pickupValue: any;
    this.coordinatesArr = [];
    if(value) {
      if(typeof value === 'string') {
        pickupValue = JSON.parse(value);
      } else {
        pickupValue = value;
      }
    };

    this.coordinatesArr = [{
      coordinates: {latitude: Number(pickupValue.latitude), longitude: Number(pickupValue.longitude)},
      hotel_name: pickupValue.Name,
      address: pickupValue.Address,
      images: this.result.additionalInfo.images
    }];

    this.dropoffLocation = {
      lat: Number(pickupValue.latitude) ?? null,
      lng: Number(pickupValue.longitude) ?? null,
      name: pickupValue.Name,
      address: pickupValue.Address,
      iata: this.payload.others.carRental.dropoffLocation.origin,
      operationTime: pickupValue.OperationTime || [],
      type: 'airport',
      country_code: 'US',
      phone: pickupValue.PhoneNumbers


    }

    this.selectedOfficeDropoff = this.dropoffLocation;
    this.selectedDropOff = this.coordinatesArr
  }

  onChangeOptional(cant: any, amount: any, i: any, optional: any) {
    let update = false;
    // eslint-disable-next-line prefer-const
    let selectOptionalAux: any[];

    this.totalOptional[i] = (parseFloat(cant) * parseFloat(amount)).toFixed(2);

    /* if (value == 0) {
      // se ubica y se borra el opcional
      this.selectOptional.forEach(function (car: any, index: any, object: any) {
        if (car.RatePlanCode === optional.RatePlanCode) {
          object.splice(index, 1);
        }
      });

    } else {
      // se actualiza
      this.selectOptional.forEach(function (car: any, index: any, object: any) {
        if (car.RatePlanCode === optional.RatePlanCode) {
            object.splice(index, 1);
            this.selectOptional.push(optional);
          update = true;
        }
      });
      // se crea
      if (!update) {
        this.selectOptional.push(optional);
      }
      this.updateOptionals =  false;
      this.searchCarsrules(optional.RatePlanCode);
    } */
    if (cant == 0) {
      selectOptionalAux = this.selectOptional.filter((element) => element.RatePlanCode !== optional.RatePlanCode);
      this.selectOptional = selectOptionalAux;
    } else {
      selectOptionalAux = this.selectOptional.filter((element) => element.RatePlanCode !== optional.RatePlanCode);
      this.selectOptional = selectOptionalAux;

      for (let index = 1; index <= cant; index++) {
        this.selectOptional.push(optional);
      }
      this.updateOptionals = false;
      // this.searchCarsrules(optional.RatePlanCode);
    }

    // asignar al objeto

    this.itemSelect.additionalInfo.carRental.RatePlanCode = optional.RatePlanCode;
    // this.itemSelect.additionalInfo.carRental.totalPrice = optional.totalNetPriceProf;
    this.itemSelect.additionalInfo.carRental.selectOptional = this.selectOptional;
    // sumar total footter
    this.totalPaymentAgency = 0;
    this.totalRent = 0;
    this.totalPrice = 0;

    // eslint-disable-next-line max-len
    this.totalPaymentAgency = (parseFloat(this.totalSumCarsFeeAgency) + parseFloat(this.sumFeePaymentAgency(this.selectOptional))).toFixed(
      2
    );
    this.totalRent = (parseFloat(this.totalPaymentUsblick) + parseFloat(this.totalPaymentAgency)).toFixed(2);
    this.totalPrice = (parseFloat(this.totalPaymentUsblick) + parseFloat(this.totalPaymentAgency)).toFixed(2);
  }



  sumFeePaymentAgency(fees: any) {
    this.paymentAgency = 0;

    fees.notIncluded.forEach((element) => {
      if (element.PaymentOffice == "true") {
        this.paymentAgency = parseFloat(this.paymentAgency) + parseFloat(element.Amount);
      }
    });

    return this.paymentAgency.toFixed(2);
  }

  _selectOptional(event: any, optional: any, index: any) {
    optional.Amount = "90.20";
    //  this.itemSelect.
    let totalPaymentAgencyAux: any = 0;
    // const checkCurrect = (document.getElementById(optional.Code) as HTMLInputElement).checked;
    const isChecked = event.target.checked;
    if (isChecked === true) {
      this.selectOptional.push(optional);
      this.updateOptionals = false;
      // this.searchCarsrules(optional.RatePlanCode);
    } else {
      totalPaymentAgencyAux = this.totalPaymentAgency;
      // eslint-disable-next-line @typescript-eslint/no-shadow

      this.selectOptional.forEach(function (car: any, index: any, object: any) {
        if (car.RatePlanCode === optional.RatePlanCode) {
          if (optional.Amount > 0) {
            totalPaymentAgencyAux = (parseFloat(totalPaymentAgencyAux) - parseFloat(optional.Amount)).toFixed(2);
          }

          object.splice(index, 1);
        }
      });
      this.totalPaymentAgency = totalPaymentAgencyAux;
    }
    // asignar al objeto

    // this.itemSelect.additionalInfo.carRental.RatePlanCode = optional.RatePlanCode;
    // this.itemSelect.additionalInfo.carRental.totalPrice = optional.totalNetPriceProf;
    this.itemSelect.additionalInfo.carRental.selectOptional = this.selectOptional;
    // sumar total footter
    this.totalPaymentAgency = 0;
    this.totalRent = 0;
    this.totalPrice = 0;

    // eslint-disable-next-line max-len
    this.totalPaymentAgency = (
      parseFloat(this.totalPaymentAgency) +
      parseFloat(this.totalSumCarsFeeAgency) +
      parseFloat(this.sumFeePaymentAgency(this.selectOptional))
    ).toFixed(2);
    // this.pricePaymentAgency = '90.80';
    this.pricePaymentAgency = this.selectOptional.reduce((accu, optional) => accu + parseFloat(optional.Amount), 0);
    this.totalRent = (parseFloat(this.totalPaymentUsblick) + parseFloat(this.pricePaymentAgency)).toFixed(2);
    // totalPaymentAgency
    this.totalPrice = (parseFloat(this.totalPaymentUsblick) + parseFloat(this.pricePaymentAgency)).toFixed(2);
  }

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str) {
    let e = str.toLowerCase() + ` O Similar`;
    return e.replace(/\b\w/g, (l) => l.toUpperCase());
  }

  // Activar Boton continue
  checkValue(event: any) {
    if (event > 0) {
      this.disableButton = false;
    } else {
      this.disableButton = true;
    }
  }

  _emitRefModal(status: string) {
    this.refModal.emit(status);
  }

  close() {
    this._emitRefModal("close");
  }

  addItinerary(item: any, itemResult: any) {
    item.taxes = itemResult.taxes ? itemResult.taxes : [];
    item.taxPrice = itemResult.taxPrice ? itemResult.taxPrice : 0; //monto impuesto por noche
    item.tax = itemResult.tax ? itemResult.tax : 0; // valor del iva aplicado
    item.profility = itemResult.additionalInfo.carRental.profility ? itemResult.additionalInfo.carRental.profility : "Falta profility";

    item.nameAdapter = itemResult.nameAdapter;
    item.images = itemResult.additionalInfo.images;
    item.id = item.id;
    item.searchId = itemResult.searchId;
    item.providerId = itemResult.providerId;
    item.providerName = itemResult.providerName;
    item.rentacarId = itemResult.id;
    item.idProduct = item.productId;
    item.categoryName = Procesed.RENT_A_CAR;
    item.title = itemResult.title;
    item.location = itemResult.additionalInfo.location;
    item.arrivalDate = itemResult.dateIni;
    item.departureDate = itemResult.dateEnd;
    item.updateDate = new Date();
    item.totalPaymentAgency = this.totalPaymentAgency;
    item.totalRent = this.totalRent;
    item.pickupSelected = this.selectedOfficePickup;
    item.dropoffSelected = this.selectedOfficeDropoff;
    item.totalPrice = itemResult.additionalInfo.carRental.totalPrice;
    item.productKey = this.getRandomUniqueId();
    item.addonsRentacar = this.arraySelectedCarfees;
    item.office = this.selectedDropOff;
    item.expiration_date =
      itemResult?.additionalInfo?.carRental?.cancellationPolicies && itemResult?.additionalInfo?.carRental?.cancellationPolicies.length > 0
        ? this.adjustDate(itemResult?.additionalInfo?.carRental?.cancellationPolicies[0].from, -1)
        : "";

    // item.ratecode = itemResult.additionalInfo.carRental.RatePlanCode;
    // se agrega el payload de busqueda de producto al objeto rentacar
    item.payloadUpdate = this._payloadUpdateRentaCar(this.payload, item);
    this.form = JSON.parse(localStorage.getItem("form"));
    // estoy llegando del home
    item.form = this.form;
    item.destination = this._itineraryService.getDestinationInfo(this.form, item);
    item.rateClass = itemResult.rateClass;

    if (this.itineraryItem) {
      item.destination = this.itineraryItem.destination;
      this._itineraryService.remove(this.itineraryItem, item);
      this._emitRefModal("success - Congratulations - Product updated succesfully");
      this.notificationService.success("Congratulations !!", "Product Successfully updated");
    } else {
      this._itineraryService.sendMessageSubscriptorLoading(true);
      this._itineraryService.add(item).subscribe(
        (response: any) => {
          if (typeof response === "string") {
            this._emitRefModal("error - Error - " + response);
          } else {
            this._itineraryService.currencySuccessEmit.next(item.currency);
            this._emitRefModal("success - Congratulations - Product added succesfully to your itinerary");
            this.notificationService.success("¡Felicitaciones! Producto agregado con éxito.");
          }
          this._itineraryService.evaluateDateItineraryRange(this._itineraryService.itinerary["items"]);
        },
        (error) => {
          this._emitRefModal("error - Error - Item was not added to your itinerary");
          this._itineraryService.sendMessageSubscriptorLoading(false);
        }
      );
    }
  }

  _payloadUpdateRentaCar(payload: any, item: any): Object {

    return {
      products: [
        {
          providerId: this.result.providerId,
          nameAdapter: this.result.nameAdapter,
          categoriesId: [2],
          // productId: this.result.id,
          productId: item.productId,
          productName: this.result.title,
          origin: "MIA", //this.result.origin,
          destination: "MIA", //this.result.destination,
          priceFrom: 0,
          priceTo: 10000.0,
          arrivalDate: this.result.dateIni,
          departureDate: this.result.dateEnd,
          qtyProduct: 1,
          qtyPax: 0,
          agencyId: this.agency.agency_id,
          others: {
            maxNumResultsPerAdapter: payload.others.maxNumResultsPerAdapter,
            maxRequestTimeOnSeconds: payload.others.maxRequestTimeOnSeconds,
            minNumResults: payload.others.minNumResults,
            carRental: payload.others.carRental,
          },
          nationality: payload.nationality,
        },
      ],
    };
  }

  getRandomUniqueId() {
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

    adjustDate(date: string | Date, days: number): string {
  if (!date) return '';

  // Convertir Date a string si es necesario
  let dateStr: string;
  if (typeof date === 'string') {
    dateStr = date;
  } else {
    // Asumiendo que es un objeto Date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    dateStr = `${year}-${month}-${day}`;
  }

  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0];
}

  rentacarLocationsDetails(): void {
    this.rentacarLocations = [];

    this.arrayResults.forEach((locations: any) => {
      const pickUp = locations.additionalInfo?.carRental?.LocationDetails.PickUp;
      const dropOff = locations.additionalInfo?.carRental?.LocationDetails.DropOff;
      const operationTime = locations.additionalInfo?.carRental?.LocationDetails.OperationTime;

      if (dropOff && pickUp) {
        this.rentacarLocations.push({ DropOff: dropOff, PickUp: pickUp, OperationTime: operationTime });
      }
    });
  }

  officesRepeated(): void {
    let officesArray: any[] = [];

    this.arrayResults.forEach((offices: any) => {
      const allOffices = offices.additionalInfo.carRental.LocationDetails;
      officesArray = officesArray.concat(allOffices);
    });

    const officesMap = new Map();

    officesArray.forEach((office: any) => {
      officesMap.set(office.PickUp.Name, office);
    });

    this.officesNotRepeated = Array.from(officesMap.values());
  }

  showWindowInfo(carSelected: any): void {
    const includeDescription = carSelected.providerName;
    if (includeDescription == "ACTIONTRAVEL") {
      this.booleanWindowInfo = true;
    }
  }

  // timesAgencies(){
  //   console.log('array result times ->', this.arrayResults);
  //   console.log('pickUptime ->', String(this.pickUpTime));
  //   console.log('dropofftime ->', this.dropOffTime);

  //   let arrayName = this.arrayResults?.additionalInfo?.carRental?.LocationDetails?.OperationTime.filter((times:any) => times.hoursStart < this.pickUpTime);
  //   console.log('time operation ->', arrayName);
  // }

  openMap(origin: string) {

    if(origin === 'pickup') {

      if(this.selectedPickup && this.selectedPickup.length === 0) {
        this.notificationService.info('Seleccione una oficina de retiro');
        return;
      }

      this.openMapPickup = !this.openMapPickup;
    } else {

      if(this.selectedDropOff && this.selectedDropOff.length === 0) {
        this.notificationService.info('Seleccione una oficina de devolución');
        return;
      }

      this.openMapDropoff = !this.openMapDropoff;
    }
  }

  dateTransform(): void {
    if (this.payload) {
      this.dateIni = moment(this.payload.arrivalDate).locale("es").format("DD [de] MMMM, YYYY");
      this.dateEnd = moment(this.payload.departureDate).locale("es").format("DD [de] MMMM, YYYY");
      this.timeIni = moment(this.payload.others.carRental.pickupLocation.pickupTime, "HH:mm:ss").format("HH:mm");
      this.timeEnd = moment(this.payload.others.carRental.dropoffLocation.dropoffTime, "HH:mm:ss").format("HH:mm");
    }
  }

  textCancellation(text: string) {
    return text
      .replace(/<ul[^>]*>/g, "")
      .replace(/<\/ul>/g, "")
      .replace(/<li[^>]*>/g, "")
      .replace(/<\/li>/g, "");
  }

  initArrayIncludes(): void {
    const priceCoverages = this.result?.additionalInfo?.carRental?.optionRates?.priceCoverages?.included;

    if (priceCoverages) {
      priceCoverages.forEach((coverage) => {
        this.includesRentacar.push(coverage);
      });
    }
  }

  insuranceRentacar(carItem:any) {
    return carItem?.additionalInfo?.carRental?.optionRates?.priceCoverages?.included || [];
  }

  insuranceRentacarNoIncluded(carItem:any) {
    return carItem?.additionalInfo?.carRental?.optionRates?.priceCoverages?.notIncluded || [];
  }

  getCancellationPolicy(data: any) {
    if (data.length > 0) {
      const cancellation = data.find((cancellation) => cancellation.amount > 0);
      return cancellation?.from;
    }
  }


loadAllOptionals(): void {
  if (!this.rentaCar?.carfeesBoolean) {
    this.officeCharges = true;
    // Caso 1: Ya vienen en el search - NO HACER CONSULTA
    this.initializeOptionalsFromSearch();
  } else {
    // Caso 2: Hacer UNA SOLA consulta para TODOS los includes
    this.getAllCarsfeesOptionals();
  }
}

// Caso 1: Ya vienen en el search - solo asignar
initializeOptionalsFromSearch(): void {
  this.arrayResults.forEach((includes, index) => {
    const carsfees = includes.additionalInfo?.carRental?.optionRates?.carsfees;
// carsfees.included.push(
//   {
//                         "code": "CD",
//                         "Amount": 321,
//                         "Currency": "USD",
//                         "DailyAmount": 0,
//                         "Name": "Gasto extra por devolver el veh\u00edculo en una oficina diferente a la de retiro.",
//                         "descripcion": "Cargo obligatorio pagadero en destino",
//                         "PaymentOffice": true,
//                         "PaymentDestination": true,
//                         "totalNetPriceProf": 396.3
//                     },
                    //  {
                    //     "code": "CDF",
                    //     "Amount": 326,
                    //     "Currency": "USD",
                    //     "DailyAmount": 0,
                    //     "Name": "Otro extra mas pa ver como va",
                    //     "descripcion": "Otro extra mas",
                    //     "PaymentOffice": true,
                    //     "PaymentDestination": true,
                    //     "totalNetPriceProf": 402.3
                    // },

// )
    if(carsfees?.included?.length > 0) {
      includes.optionalMandatoryRentacarArray = carsfees.included.map((opt) => ({
        ...opt,
        qtyOptional: 0,
        disabledQty: true,
        includesIndex: index
      }));

      includes.optionalMandatoryRentacarArray.forEach((optional: any) => {
      const eventOption: any = {target:{checked: true}};
        this.optionalSelected(eventOption, optional, includes);
        this.incrementOptional(optional, includes);
      });
    } else {
      includes.optionalMandatoryRentacarArray = [];
    }



    if (carsfees?.notIncluded?.length > 0) {
      includes.optionalRentacarArray = carsfees.notIncluded.map((opt) => ({
        ...opt,
        qtyOptional: 0,
        disabledQty: true,
        includesIndex: index
      }));
    } else {
      includes.optionalRentacarArray = [];
    }
  });
}

// Caso 2: UNA SOLA consulta para TODOS
getAllCarsfeesOptionals(): void {
  // 1. Mostrar loading ANTES de todo
  const loadingToast = this.notificationService.loading('Cargando adicionales y oficinas');

  // 2. Armar UN SOLO payload con TODOS los productos
  const products = this.arrayResults.map((item) => ({
    providerId: item?.providerId,
    categoryId: [this?.payload?.categoriesId[0]],
    productId: item?.productId,
    ratecode: item?.additionalInfo?.carRental?.RatePlanCode,
  }));

  const payload = [{ products }];

  // 3. Hacer la petición
  this._rest.doPost("app", "products/rentacar/get-aditional-fees", payload[0]).subscribe({
    next: (res: any) => {
      if (res?.results) {
        // 4. Procesar cada resultado (mapeo completo)
        this.arrayResults.forEach((includes, index) => {
          const result = res.results[index];

          if (result?.pickupOffices && result.pickupOffices.length > 0) {
            this.result.pickupOffices = result.pickupOffices;
          }

          if (result?.dropoffOffices && result.dropoffOffices.length > 0) {
            this.result.dropoffOffices = result.dropoffOffices;
          }
          // ✅ GUARDAR LOS VALORES ORIGINALES DE additionalInfo.carRental ANTES DE MODIFICAR
          if (includes?.additionalInfo?.carRental) {

            includes.originalCarRentalValues = {
              netPriceProf: includes.additionalInfo.carRental.netPriceProf || 0,
              netPriceFreeTax: includes.additionalInfo.carRental.netPriceFreeTax || 0,
              price: includes.additionalInfo.carRental.price || 0,
              totalPrice: includes.additionalInfo.carRental.totalPrice || 0,
              totalPriceFreeTax: includes.additionalInfo.carRental.totalPriceFreeTax || 0,
              totalPriceProf: includes.additionalInfo.carRental.totalPriceProf || 0,
              profility: includes.additionalInfo.carRental.profility,
              mandatoryPriceProf: includes.additionalInfo.carRental.mandatoryPriceProf || 0,
              mandatoryPrice: includes.additionalInfo.carRental.mandatoryPrice || 0,
              netPriceBooking: includes.additionalInfo.carRental.netPriceBooking || 0,
              netPriceAgent: includes.additionalInfo.carRental.netPriceAgent || 0
            };
          }

          // Procesar fees incluidos (obligatorios)
          if (result?.carsfees?.included?.length > 0) {
            includes.optionalMandatoryRentacarArray = result.carsfees.included.map((opt) => ({
              ...opt,
              qtyOptional: 0,
              disabledQty: true,
              includesIndex: index
            }));

            includes.optionalMandatoryRentacarArray.forEach((optional: any) => {
              const eventOption: any = { target: { checked: true } };
              this.optionalSelected(eventOption, optional, includes);
              this.incrementOptional(optional, includes);
            });


            if (result?.totalPriceProf) {
              // ✅ Calcular diferencias con valores por defecto (0 si es undefined)
              const netPriceProfDiff: number = (includes.originalCarRentalValues.netPriceProf + Number(includes.originalCarRentalValues.mandatoryPrice || 0))
                  - ((result?.netPriceProf || 0) + Number(result?.mandatoryPrice || 0));

              const totalPriceProfDiff: number = (includes.originalCarRentalValues.totalPriceProf + Number(includes.originalCarRentalValues.mandatoryPrice || 0))
                  - ((result?.totalPriceProf || 0) + Number(result?.mandatoryPrice || 0));

              const netPriceFreeTaxDiff: number = (includes.originalCarRentalValues.netPriceFreeTax + Number(includes.originalCarRentalValues.mandatoryPrice || 0))
                  - ((result?.netPriceFreeTax || 0) + Number(result?.mandatoryPrice || 0));

              const priceDiff: number = (Number(includes.originalCarRentalValues.price || 0) + Number(includes.originalCarRentalValues.mandatoryPrice || 0))
                  - ((result?.price || 0) + Number(result?.mandatoryPrice || 0));

              const totalPriceDiff: number = Number(includes.originalCarRentalValues.totalPrice || 0) - Number(result?.mandatoryPrice || 0);


              const totalPriceFreeTaxDiff: number = (includes.originalCarRentalValues.totalPriceFreeTax + Number(includes.originalCarRentalValues.mandatoryPrice || 0))
                  - ((result?.totalPriceFreeTax || 0) + Number(result?.mandatoryPrice || 0));



              // ✅ Asignar valores actualizados con valores por defecto
              includes.additionalInfo.carRental.netPriceProf = (result?.netPriceProf || 0) + Number(result?.mandatoryPrice || 0) + netPriceProfDiff;
              includes.additionalInfo.carRental.netPriceFreeTax = (result?.netPriceFreeTax || 0) + Number(result?.mandatoryPrice || 0) + netPriceFreeTaxDiff;
              includes.additionalInfo.carRental.price = Number(result?.price || 0) + Number(result?.mandatoryPrice || 0) + priceDiff;
              includes.additionalInfo.carRental.totalPrice = Number(result?.totalPrice || 0) + Number(result?.mandatoryPrice || 0);
              includes.additionalInfo.carRental.totalPriceFreeTax = (result?.totalPriceFreeTax || 0) + Number(result?.mandatoryPrice || 0) + totalPriceFreeTaxDiff;
              includes.additionalInfo.carRental.totalPriceProf = (result?.totalPriceProf || 0) + Number(result?.mandatoryPrice || 0) + totalPriceProfDiff;

              // ✅ Profility con todos sus campos y valores por defecto
              includes.additionalInfo.carRental.profility = {
                  netPrice: Number(result?.totalPrice || 0) + Number(result?.mandatoryPrice || 0),
                  netPriceCategory: (result?.profility?.netPriceCategory || 0) + Number(result?.mandatoryPrice || 0) + totalPriceProfDiff,
                  netPriceProvider: (result?.profility?.netPriceProvider || 0) + Number(result?.mandatoryPrice || 0) + totalPriceProfDiff,
                  netPriceBooking: (result?.profility?.netPriceBooking || 0) + Number(result?.mandatoryPrice || 0) + totalPriceProfDiff,
                  netPriceAgent:  (result?.profility?.netPriceBooking || 0) + Number(result?.mandatoryPrice || 0) + totalPriceProfDiff,
                  percentage: result?.profility?.percentage || 0,
                  percentageCategory: result?.profility?.percentageCategory || 0,
                  percentageProvider: result?.profility?.percentageProvider || 0,
                  percentageBooking: result?.profility?.percentageBooking || 0,
                  blickoins: (result?.profility?.blickoins || 0) + totalPriceProfDiff * 0.2,
                  creditBlickoins: (result?.profility?.creditBlickoins || 0) + totalPriceProfDiff * 0.02
              };

              includes.additionalInfo.carRental.mandatoryPriceProf = result?.mandatoryPrice || 0;
              includes.additionalInfo.carRental.mandatoryPrice = result?.mandatoryPrice || 0;


          }

          } else {
            includes.optionalMandatoryRentacarArray = [];
          }

          // Procesar fees no incluidos (opcionales)
          if (result?.carsfees?.notIncluded) {
            includes.optionalRentacarArray = result.carsfees.notIncluded.map((opt) => ({
              ...opt,
              qtyOptional: 0,
              disabledQty: true,
              includesIndex: index
            }));
          } else {
            includes.optionalRentacarArray = [];
          }

        });

        this.officeCharges = false;
      }

      // 5. Todo el proceso ha terminado - Ocultar loading
      this.notificationService.close(loadingToast);
      this.cdr.detectChanges();
      this.notificationService.success('Adicionales y oficinas cargados correctamente');
    },
    error: (error: any) => {
      this.notificationService.close(loadingToast);
      this.notificationService.error('Error al cargar los adicionales', 'Error');
      console.error('Error loading car fees:', error);
      this.cdr.detectChanges();
    }
  });
}

  optionalSelected(event: any, optional: any, car: any): void {

    if (event.target.checked) {
      optional.disabledQty = false;
      this.arraySelectedCarfees.push(optional);
    } else {
      const carsfeeSelected = this.arraySelectedCarfees.findIndex((opt: any) => opt.Name === optional.Name);
      optional.disabledQty = true;
      if (carsfeeSelected !== -1) {
        this.arraySelectedCarfees.splice(carsfeeSelected, 1);
      }
    }

    if(this.arraySelectedCarfees.length > 0){
      this.calculateTotalPrice();
    }
  }

  /**
   * Calcula el precio total junto con los incluidos
   */
  calculateTotalPrice() {

    let totalPriceOptional = this.arraySelectedCarfees.reduce((acc, opt) => acc + opt.qtyOptional * opt.Amount, 0);

  }

decrementOptional(optional: any, car: any) {
  optional.qtyOptional--;

  if (optional.qtyOptional <= 0) {
    optional.qtyOptional = 0;

    // Eliminar del array addonsIncluded cuando llega a 0
    const index = car.additionalInfo?.carRental?.addonsIncluded.findIndex(
      c => c.Code === optional?.Code
    );

    if (index >= 0) {
      // Remover del array
      car.additionalInfo.carRental.addonsIncluded.splice(index, 1);

      // RESTAR el precio (acción = false para restar)
      this.refreshPrice(optional, 1, car, false);
    }

    return;
  }

  // Si aún tiene cantidad, actualizar el existente
  const index = car.additionalInfo?.carRental?.addonsIncluded.findIndex(
    c => c.Code === optional?.Code
  );

  if (index >= 0) {
    const optionalExists = car.additionalInfo.carRental.addonsIncluded[index];

    // ACTUALIZAR la cantidad en el objeto existente
    optionalExists.qtyOptional = optional.qtyOptional;

    // REFRESCAR: restamos 1 unidad (la que acabamos de decrementar)
    this.refreshPrice(optional, 1, car, false);
  }
}

incrementOptional(optional: any, car: any) {

  optional.qtyOptional++;

  if (optional.qtyOptional >= 5) {
    optional.qtyOptional = 5;
    return;
  }

  const index = car.additionalInfo?.carRental?.addonsIncluded.findIndex(
    c => c.code === optional?.code
  );

  // Calcular precio total por los días
  const days = Number(this.days) || 1;
  const totalAmount = Number(optional.Amount) * optional.qtyOptional;

  if (index >= 0) {
    // YA EXISTE - actualizar cantidad y precio total
    const optionalExists = car.additionalInfo.carRental.addonsIncluded[index];
    optionalExists.qtyOptional = optional.qtyOptional;
    optionalExists.totalAmount = totalAmount; // 👈 GUARDAR PRECIO TOTAL
    optionalExists.displayPrice = totalAmount; // 👈 PARA MOSTRAR EN TEMPLATE

    // SUMAR solo 1 unidad
    this.refreshPrice(optional, 1, car, true);

  } else {
    // NO EXISTE - agregar NUEVO con precio total
    const newOptional = {
      ...optional,
      qtyOptional: optional.qtyOptional,
      totalAmount: totalAmount,           // 👈 PRECIO TOTAL × DÍAS
      displayPrice: totalAmount,          // 👈 PARA MOSTRAR
      dailyAmount: Number(optional.Amount), // 👈 OPCIONAL: guardar precio diario
      days: days                         // 👈 OPCIONAL: guardar días
    };
    car.additionalInfo.carRental.addonsIncluded.push(newOptional);

    // SUMAR la cantidad total
    this.refreshPrice(optional, optional.qtyOptional, car, true);
  }

}

refreshPrice(optional: any, qtyToChange: number, car: any, isAdding: boolean): void {

  const days = Number(this.days) || 1;

  const dailyAmount = Number(optional.totalNetPriceProf);
  const amountToChange = dailyAmount * qtyToChange;
  const operator = isAdding ? 1 : -1;
  const changeValue = amountToChange * operator;

  // Actualizar precios principales
  car.additionalInfo.carRental.netPriceFreeTax += changeValue;
  car.additionalInfo.carRental.netPriceProf += changeValue;
  car.additionalInfo.carRental.totalPriceFreeTax += changeValue;
  car.additionalInfo.carRental.totalPriceProf += changeValue;
  // Actualizar price, totalPrice y totalPricePlan
  let price = Number(car.additionalInfo.carRental.price);
  let totalPrice = Number(car.additionalInfo.carRental.totalPrice);
  let totalPricePlan = Number(car.additionalInfo.carRental.optionRates.plan.totalPrice);

  price += changeValue;
  totalPrice += changeValue;
  totalPricePlan += changeValue;

  car.additionalInfo.carRental.price = price.toString();
  car.additionalInfo.carRental.totalPrice = totalPrice.toString();
  car.additionalInfo.carRental.optionRates.plan.totalPrice = totalPricePlan.toString();
  // Actualizar profility
  if (car.additionalInfo.carRental.profility) {
    car.additionalInfo.carRental.profility = {
      netPriceCategory: (car.additionalInfo.carRental.profility.netPriceCategory || 0) + changeValue,
      netPriceProvider: (car.additionalInfo.carRental.profility.netPriceProvider || 0) + changeValue,
      netPriceBooking: (car.additionalInfo.carRental.profility.netPriceBooking || 0) + changeValue,
      blickoins: car.additionalInfo.carRental.profility.blickoins,
      creditBlickoins: car.additionalInfo.carRental.profility.creditBlickoins,
      percentage: car.additionalInfo.carRental.profility.percentage,
      percentageCategory: car.additionalInfo.carRental.profility.percentageCategory,
      percentageProvider: car.additionalInfo.carRental.profility.percentageProvider,
      percentageBooking: car.additionalInfo.carRental.profility.percentageBooking
    };
  }

}


    /**
 * Abre o cierra el acordeón de políticas y hace scroll suave a la sección cuando se abre
 */
  openPolitics(): void {
    if (this.politicsAccordion) {
      this.politicsAccordion.toggleOpen();

      // Solo hacé scroll si lo estás abriendo
      if (!this.politicsAccordion.isOpen) {
        setTimeout(() => {
          if (this.politicsSection?.nativeElement) {
            this.politicsSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 200);
      }
    }
  }

  getOfficesPickup(result): any[] {

    if(this.officeCharges) {
    return result.additionalInfo.carRental.LocationDetails.PickUp || [];
    } else {
       return result.pickupOffices || [];
    }

  }

    getOfficesDropoff(result): any[] {
    if(this.officeCharges) {
       return result.additionalInfo.carRental.LocationDetails.DropOff || [];
    } else {
      return result.dropoffOffices || [];
    }

  }

  getPriceAddons(addonsIncluded: any[]): number {
    if (!addonsIncluded || addonsIncluded.length === 0) {
      return 0;
    }

    const addonsIncludedPaymentOffice: any[] = addonsIncluded.filter(c => c.PaymentOffice === true);

    return addonsIncludedPaymentOffice.reduce((total, addon) => {
      return total + ((addon.totalNetPriceProf * addon.qtyOptional) || 0);
    }, 0);
  }

onAccordionToggle(index: number): void {

    this.isMainExpandedExcutiveAction[index] = !this.isMainExpandedExcutiveAction[index];

  }

    accordionItems(): AccordionItem[] {
      return [
         {
          id: 'requirements',
          title: 'Requisitos',
          icon: '',
          data: { requirements: this.result.additionalInfo?.carRental?.requirements }
        },
        {
          id: 'policies',
          title: 'Políticas de Cancelación y Penalidades',
          icon: 'assets/icons/policy.svg',
          data: { policies: this.cancellationPolicies }
        }
      ];


      }

      cancellationPolicies(): ICancellationPolicyModalResultsDisplayData {
        return {
          rateClass: this.result?.rateClass,
          cancellationPolicies: this.result.additionalInfo?.carRental?.cancellationPolicies || [],
          currencyCancellation: this.result.additionalInfo.carRental.currency,
          amount: this.result.additionalInfo?.carRental?.cancellationPolicies?.find(c => c.amount > 0)?.amountProf || 0,
          from: this.result.additionalInfo?.carRental?.cancellationPolicies?.find(c => c.amount > 0)?.from || 'N/A',
          cancellationFree: this.result.additionalInfo?.carRental?.cancellationPolicies?.some(c => Number(c.amount) === 0),
          cancellationPoliciesDescription: this.result.additionalInfo?.carRental?.cancellationPoliciesText || '',
          arrivalDate: this.payload?.arrivalDate,
        }
      }

          accordionConfig(): AccordionConfig {
           return {
            multiple: false,
            animated: true,
            showArrows: true,
            borderTop: true,
            defaultOpen: this.tab === 'INCLUDES' ? ['cancellation'] : ['description']
           }
          };


}
